import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  position: absolute;
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

const UnfilledCircle = ({
  circleDiameter,
  className,
  color,
  thickness,
  size
}) => {
  return (
    <Wrapper $size={size}>
      <svg
        viewBox={`${circleDiameter / 2} ${
          circleDiameter / 2
        } ${circleDiameter} ${circleDiameter}`}
      >
        <circle
          className={className}
          cx={circleDiameter}
          cy={circleDiameter}
          r={(circleDiameter - thickness) / 2}
          fill="none"
          strokeWidth={thickness}
          stroke={color}
        />
      </svg>
    </Wrapper>
  );
};

UnfilledCircle.propTypes = {
  circleDiameter: PropTypes.number,
  className: PropTypes.string,
  color: PropTypes.string,
  thickness: PropTypes.number,
  size: PropTypes.number
};

UnfilledCircle.defaultProps = {
  circleDiameter: 44,
  className: '',
  color: 'var(--color-i-blue)',
  thickness: 3.6,
  size: 40
};

export default UnfilledCircle;
